import { CartApiClientUtils } from '../utils/cart-api-client.utils';
import { decimalPrice, formatPrice, PricingApiClient } from '../../premium-pricing-api-client';
import { mappers } from '@wix/premium-cart-common';
export const queryCartPricing = async _ref => {
  var _cart$totalAmounts;
  let {
    httpClient,
    request
  } = _ref;
  const {
    getSubtotalFromDynamicOffering
  } = request;
  const {
    getEnrichedCurrentCart
  } = await CartApiClientUtils.dynamicLoadCartQueries(httpClient);
  const {
    cart
  } = await getEnrichedCurrentCart({});
  if (!cart) {
    // TODO - error
    throw new Error('No cart in queryCartPricing');
  }
  const {
    lineItems
  } = cart;
  let entireCartMaximalPrice = 0;
  const filteredLineItems = Object.values(lineItems).filter(lineItem => {
    var _lineItem$cycle, _lineItem$productInfo, _lineItem$productInfo2;
    return Boolean((_lineItem$cycle = lineItem.cycle) == null ? void 0 : _lineItem$cycle.cycleDuration) && Boolean((_lineItem$productInfo = lineItem.productInfo) == null ? void 0 : _lineItem$productInfo.productId) && Boolean((_lineItem$productInfo2 = lineItem.productInfo) == null ? void 0 : _lineItem$productInfo2.productTypeId);
  });
  const lineItemsDisplayProps = await Promise.all(Object.values(filteredLineItems).map(async lineItem => {
    var _lineItem$productInfo3, _lineItem$productInfo4, _lineItem$productInfo5, _lineItem$productInfo6;
    if (!(lineItem != null && lineItem.cycle) || !(lineItem != null && (_lineItem$productInfo3 = lineItem.productInfo) != null && _lineItem$productInfo3.productId) || !(lineItem != null && (_lineItem$productInfo4 = lineItem.productInfo) != null && _lineItem$productInfo4.productTypeId)) {
      // TODO - handle
      return Promise.resolve();
    }
    const dynamicCycle = mappers.CartCycleToDynamicCycle(lineItem.cycle);
    if (!dynamicCycle.interval) {
      // TODO - handle
      return Promise.resolve();
    }
    const {
      displayProps
    } = await PricingApiClient.query.cyclePricingDisplayProps({
      httpClient,
      request: {
        interval: dynamicCycle.interval,
        productId: lineItem == null || (_lineItem$productInfo5 = lineItem.productInfo) == null ? void 0 : _lineItem$productInfo5.productId,
        productTypeId: lineItem == null || (_lineItem$productInfo6 = lineItem.productInfo) == null ? void 0 : _lineItem$productInfo6.productTypeId
      }
    });
    return displayProps;
  }));
  entireCartMaximalPrice = lineItemsDisplayProps.reduce((acc, displayProps) => acc + ((displayProps == null ? void 0 : displayProps.maximalTotalPrice) ?? 0), 0);
  const entireCartSubtotalPriceFromDynamicOffering = lineItemsDisplayProps.reduce((acc, displayProps) => acc + ((displayProps == null ? void 0 : displayProps.totalPrice) ?? 0), 0);
  const cartSubtotal = getSubtotalFromDynamicOffering ? entireCartSubtotalPriceFromDynamicOffering : Number(cart == null || (_cart$totalAmounts = cart.totalAmounts) == null ? void 0 : _cart$totalAmounts.subTotal);

  // we have totalsAmount in cart model so why do we need this?
  const totalSavings = entireCartMaximalPrice - cartSubtotal;
  const {
    currencySettings
  } = await PricingApiClient.query.currencySettings({
    httpClient,
    request: {}
  });
  const totalSavingsStr = formatPrice(totalSavings, currencySettings);
  const totalSavingsDecimal = decimalPrice(totalSavings, currencySettings);
  const cartSubtotalStr = formatPrice(Number(cartSubtotal), currencySettings);
  const cartSubtotalDecimal = decimalPrice(Number(cartSubtotal), currencySettings);
  return {
    totalSavings,
    totalSavingsStr,
    totalSavingsDecimal,
    cartSubtotal,
    cartSubtotalStr,
    cartSubtotalDecimal
  };
};
//# sourceMappingURL=queryCartPricing.js.map